<template>
  <div>
    <div style="margin-top: 20px">
      <!-- <el-button type="primary" @click="printPdf">打印合同</el-button> -->
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button type="primary">
          上传合同
        </el-button>
      </el-upload>

      <!-- <el-button type="primary" @click="downFiles">下载合同</el-button> -->
      <el-button type="primary" @click="goEsing">
        电子签章
      </el-button>
    </div>
    <ul class="el-upload-list el-upload-list--text" style="margin: 10px 0">
      <el-row :gutter="60">
        <el-col v-for="(item ,index) in fileList" v-show="item.loading" :key="index" :span="9" class="el-col-auto">
          <li tabindex="0" class="el-upload-list__item is-success">
            <a class="el-upload-list__item-name">
              <i class="el-icon-document" />
              {{ item.enclosureName }}
            </a>
            <label v-if="!item.loading" class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check" />
            </label>
            <el-progress v-if="item.loading" style="margin-top: 5px" :percentage="item.percentage" :stroke-width="4" :show-text="false" />
          </li>
        </el-col>
      </el-row>
    </ul>
    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column prop="fileName" label="文件名称" align="left" fixed="left" min-width="150">
        <template v-slot="{row}">
          <el-button type="text" @click="openContract(row)">
            {{ row.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left" fixed="right" class-name="download-file-loading">
        <template v-slot="{row}">
          <div v-loading="row.isLoading" element-loading-spinner="el-icon-loading">
            <el-popover v-model="row.removeVisible" width="160">
              <p style="line-height: 30px">
                确认删除该文件吗?
              </p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="row.removeVisible = false">
                  取消
                </el-button>
                <el-button type="primary" size="mini" @click="removeFile(row)">
                  确定
                </el-button>
              </div>
              <el-button slot="reference" type="text" style="color: #F56C6C;">
                删除
              </el-button>
            </el-popover>
            <el-button type="text" style="margin-left: 10px" @click="downOneFile(row)">
              下载
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <do-esign ref="doEsign" @CompleteEsign="CompleteEsign" />
  </div>
</template>
<script type="es6">
import {
  getAttachmentListByContractId,
  attachmentGetToken,
  uploadAfterSaveInfo,
  deleteByContractIdAndAttachmentId,
  getTokenForDownZip,
  electronicSignature,
  printContractPDF,
  getUrlByFileID
} from '@/API';
import { getAliOSSDownloadInfo } from '@/API/international';
import doEsign from '@/components/doEsign';
import AxiosApi from '@/API/fileAxios';

export default {
  data () {
    return {
      tableData: [],
      multipleSelection: [],
      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: ''
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    doEsign
  },
  computed: {},
  methods: {
    searchFiles () {
      this.tableLoading = true;
      getAttachmentListByContractId(this.contractNum).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    downFiles () {
      if (!this.multipleSelection.length) {
        this.$notify({
          title: '请至少选择一个文件',
          type: 'warning'
        });
        return;
      }
      if (this.multipleSelection.length === 1) {
        this.downOneFile(this.multipleSelection[0].fileToken);
      } else {
        let fileIds = [];
        this.multipleSelection.forEach((item) => {
          fileIds.push(item.fileToken);
        });
        getTokenForDownZip({
          catalogName: '附件集合',
          fileIds
        }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.downzipFile(json.data.token, json.data.downloadZipUrl);
          }
        }).catch(() => {

        });
      }
    },
    downOneFile (row) {
      if (Number(row.cloudAddress) === 1) {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (Number(status) === 200) {
            this.fileserveDownUrl = data.fileInfo.url;
            this.$nextTick(() => {
              this.$refs.downTag.click();
            });
          }
        }).catch(() => {
        });
      } else {
        this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
        this.$nextTick(() => {
          this.$refs.downTag.click();
        });
      }
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitfile (files) {
      this.tableLoading = true;
      uploadAfterSaveInfo(files).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.searchFiles();
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    checkSpecialCharacters (str) {
      // return str.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '');
      // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      let form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      let myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.submitfile([{
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
            contractId: this.contractNum
          }]);
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    removeFile (row) {
      this.tableLoading = true;
      deleteByContractIdAndAttachmentId({
        contractId: row.contractId,
        attachmentId: row.id
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.searchFiles();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    goEsing () {
      electronicSignature(this.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.doEsign.openWindow(json.data);
        }
      }).catch(() => {

      });
    },
    CompleteEsign (val) {
      if (val.isComplete) {
        this.searchFiles();
      }
    },
    printPdf () {
      printContractPDF(this.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.fileserveDownUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(json.data)}`;
          this.$nextTick(() => {
            this.$refs.downTag.click();
          });
        }
      }).catch(() => {

      });
    },
    openContract (row) {
      if (Number(row.cloudAddress) === 1) {
        getAliOSSDownloadInfo(row.fileToken).then(({ status, data }) => {
          if (Number(status) === 200) {
            window.open(data.fileInfo.url);
          }
        }).catch(() => {
        });
      } else {
        getUrlByFileID(row.fileToken).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            window.open(json.data);
          }
        }).catch((res) => {

        });
      }
    }
  },
  mounted () {
    this.searchFiles();
    this.initToken();
  }
};
</script>
<style>
/deep/ .el-loading-spinner{
  padding-top:10px;
}
</style>
